module.exports = __webpack_public_path__ + "static/media/anchor.4a013866.svg";